import React from 'react';
import './styles/index.css';
import LazyLoad from 'react-lazyload';
import LearningPathSVG from './LearningPathSvg';
import LearningPathMobileSVG from './LearningPathMobileSvg';

export default function LearningPath() {
  return (
    <section className="outer-section learning-path-section">
      <h2 className="darkTxt weight-600 pb-4">
        Our Learning Path{' '}
        <span className="d-flex flex-column flex-sm-row justify-content-center brandTxt headingFont weight-600 pt-1">
          Absolute Beginner<div className="learning-path-arrow weight-500 mx-2">&#10132;</div>Algorithmic Programmer
        </span>
      </h2>
      <div className="inner-section learning-path-img-container no-pointers">
        <div className="d-md-none">
          <LazyLoad offset={0} height="500px">
            <LearningPathMobileSVG />
          </LazyLoad>
        </div>
        <div className="d-none d-md-block">
          <LazyLoad offset={0} height="500px">
            <LearningPathSVG />
          </LazyLoad>
        </div>
      </div>
    </section>
  );
}
